import { PublicClientApplication } from '@azure/msal-browser';

export const authConfig = {
  clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
  authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_APPLICATION_ID}`,
  redirectUri: `${process.env.REACT_APP_URL_BASE}home`,
  navigateToLoginRequestUrl: true,
  applicationId: process.env.REACT_APP_AZURE_APPLICATION_ID,
};

const cache = {
  cacheLocation: 'localStorage',
  storeAuthStateInCookie: false,
};

const getMsalConfig = () => {
  const msalConfig = {
    auth: authConfig,
    cache: cache,
  };

  return msalConfig;
};

const msalConfig = getMsalConfig();
export const msalInstance = new PublicClientApplication(msalConfig);
